import { dispatch } from './store'

export const prepareForm = async (formId: string, callback: () => any) => {
    dispatch((draft) => (draft.formsReady = draft.formsReady.delete(formId)))
    await callback()
    dispatch((draft) => (draft.formsReady = draft.formsReady.add(formId)))
}
